import { Box, Typography } from "@mui/material";

const DataTable = ({ columns = [], rows = [], getRowId = (row, index) => row.id || index }) => (
  <Box sx={{ overflowX: "auto", border: "1px solid", borderColor: "divider", borderRadius: 1, background: (theme) => theme.custom.glass.background, boxShadow: (theme) => theme.custom.glass.boxShadow }}>
    <Box component="table" sx={{ width: "100%", borderCollapse: "collapse", "& th, & td": { px: 2, py: 1.5, borderBottom: "1px solid", borderColor: "divider", textAlign: "left" }, "& th": { bgcolor: (theme) => theme.custom.surface.inset }, "& tbody tr:last-child td": { borderBottom: 0 }, "& tbody tr:hover": { bgcolor: "action.hover" }, "& td": { minWidth: 100 } }}>
      <thead>
        <tr>
          {columns.map((column) => <th key={column.key}><Typography variant="caption" color="text.secondary">{column.header}</Typography></th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          <tr key={getRowId(row, index)}>
            {columns.map((column) => (
              <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </Box>
  </Box>
);

export default DataTable;
